import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/Supplier`;

const headers = {
  'Content-Type': 'multipart/form-data',
};

const ApiSupplier = {
  getAllAgency: (params) => {
    const url = `${baseServiceUrl}/getAllAgency`;
    return ServiceApi.get(url, { params });
  },
  getSupplierById: (params) => {
    const url = `${baseServiceUrl}/getSupplierById?id=` + params;
    return ServiceApi.get(url, { params });
  },
  getEnumType: () => {
    const url = `${baseServiceUrl}/getAgencyType`;
    return ServiceApi.get(url);
  },
  createAgency: (params) => {
    const url = `${baseServiceUrl}/createAgency`;
    return ServiceApi.post(url, params);
  },
  createandEditSupplierCommand: (params) => {
    const url = `${baseServiceUrl}/createandEditSupplierCommand`;
    return ServiceApi.post(url, params);
  },
  updateAgency: (params) => {
    const url = `${baseServiceUrl}/updateAgency`;
    return ServiceApi.put(url, params);
  },
  getAllRegion: () => {
    const url = `${baseServiceUrl}/allRegion`;
    return ServiceApi.get(url);
  },
  getLicenseTypeStatus: (params) => {
    const url = `${baseServiceUrl}/getEnumType`;
    return ServiceApi.get(url, { params });
  },
  getListFiles: (params) => {
    const url = `${baseServiceUrl}/getListFiles`;
    return ServiceApi.get(url, { params });
  },
  getFile: (params) => {
    const url = `${baseServiceUrl}/getFile`;
    return ServiceApi.get(url, { params: params, responseType: 'blob' });

  },
  getAllTicket: (ticketNumber) => {
    const url = `${baseServiceUrl}/getAllTicket`;
    return ServiceApi.get(url);
  },
  getTicketById: (ticketNumber) => {
    const url = `${baseServiceUrl}/getTicketById`;
    return ServiceApi.get(url, {
      params: {
        ticketNumber: ticketNumber,
      },
    });
  },
  cancelTickets: (params) => {//ابطال بلیط
    const url = `${baseServiceUrl}/cancelTickets`;
    return ServiceApi.post(url, params);
  },
  getCancelledTickets: (params) => {
    const url = `${baseServiceUrl}/getCancelledTickets`;
    return ServiceApi.post(url, params);
  },

};

export default ApiSupplier;


